import React from 'react';

import { useExtensionRequestsReport, useExtensionRequestsReportCsv } from 'api';
import { useExtensionRequestsFilters } from './hooks';
import { BaseReport } from '../..';

export const ExtensionRequestsReport: React.FC = () => {
  useExtensionRequestsReport();
  const filters = useExtensionRequestsFilters();
  const { mutate: exportCsv } = useExtensionRequestsReportCsv();

  return <BaseReport filters={filters} exportCsv={exportCsv} />;
};
